const utils = require("@/libs/utils");

module.exports = {
  open(page, params) {
    switch (page) {
      case 'family_miniprogram':
        let path = params && params.path ? encodeURIComponent(params.path) : 'pages%2FstartIndex%2FStartIndex%3Fsource%3Dapp%26channel%3Dapp_checkout%26perferStoreCode%3D549'
        location.href = `https://ikeaapp/miniprogram?name=gh_eca4e999a0de&path=${path}`;
        break;
      case 'coupon':
        location.href = `https://ikeaapp/coupon?target=flutter`;
        break;
      case 'order_detail':
        location.href = `https://ikeaapp/order_detail?order_id=${params.id}`;
        break;
      case 'cms_page':
        location.href = `https://ikeaapp/cms/page?id=${params.id}`;
        break;
      case 'link':
        this._openLink(params.link)
        break;
      case 'product':
        let url = `https://ikeaapp/product?type=${params.type}&id=${params.id}`;
        if (params['seriesId']) {
          url = url + `&seriesId=${params.seriesId}`
        }
        location.href = url
        break;
      case 'customer_service':
        let cPage = params.page
        if (cPage) {
          location.href = `https://ikeaapp/customer_service?page=${cPage}`
        } else {
          location.href = 'https://ikeaapp/customer_service'
        }
        break;
      case 'customer_service_tel':
        location.href = 'https://ikeaapp/customer_service_tel'
        break;
      case 'assembly_service_introduction':
        location.href = 'https://ikeaapp/assembly_service_introduction'
        break;
      case 'web':
        location.href = 'https://ikeaapp/web?path=' + encodeURIComponent(params.path) + params.additionalParams || ''
        break;
      case 'login':
        const version = utils.getClientVersion()
        if (version >= '2.3.0' && version < '2.5.0') {
          location.href = 'https://ikeaapp/CiamModule/login?canWechatLogin=true';
          } else {
          location.href = 'https://ikeaapp/login';
        }

        break;
      case 'shareInfo':
        location.href = 'https://ikeaapp/shareInfo?data=' + params.data;
        break;
      case 'add_multi_product_to_cart':
        location.href = `https://ikeaapp/add_multi_product_to_cart?source=${params.source}&products=${params.productList}`
        break;
      case 'popCurrent':
        location.href = `https://ikeaapp/popCurrent`
        break
    }
  },
  // TODO move link resolve logic to server
  _openLink(link) {
    if (link.resolvedUrl) {
      location.href = link.resolvedUrl
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/router/platform/ikeaapp.js